import { HomeSessionTabs } from './HomeSessionTabs';
export default HomeSessionTabs;
